export const QUOTE_ELIGIBILITY = [
  {
    id: "1",
    text: "Your property will not be permanently occupied by anybody other than you and/or your family. Family means you, your partner and any other person permanently living with you (including children or foster children). Excludes lodgers and any other tenants not covered under your tenancy agreement.",
  },
  {
    id: "2",
    text: "The property does not have signs of or has never had any damage caused to it by landslip, subsidence, or heave.",
  },
  {
    id: "3",
    text: "You or any member of your family to be insured do not have any unspent convictions or prosecutions pending (other than motor convictions).",
  },
  {
    id: "4",
    text: "You or any member of your family have not had insurance cancelled, declined, declared void, or had any special terms imposed.",
  },
  {
    id: "5",
    text: "The home or the land belonging to it has not flooded in the last 10 years.",
  },
  {
    id: "6",
    text: "The property will not be left unoccupied for a total of more than 60 days in a row.",
  },
  {
    id: "7",
    text: "The property will not be used for business or professional purposes, other than clerical work undertaken by you and your family.",
  },
];

export const HOME_ELIGIBILITY = [
  {
    id: "1",
    text: "Your property will not be permanently occupied by anybody other than you and/or your family. Family is defined as you, your partner and any other person permanently living with you (including any children or foster children). Excludes lodgers and any other tenants not covered under your tenancy agreement.",
  },
  {
    id: "2",
    text: "The property does not have signs of or has never had any damage caused to it by landslip, subsidence or heave.",
    expandContent:
      "<p class='mb-4 mt-4'>If your property has suffered a claim for landslip, subsidence or heave, we will not be able to provide cover. If you are unsure, this information can normally be found within a previous property survey. Please see below for descriptions of each.</p><p> Landslip - Downward movement of sloping ground. <br />Subsidence - Downward movement of the ground beneath the buildings, other than by settlement. <br />Heave - Upward movement of the ground beneath the buildings as a resultof the soil expanding.</p>",
    eventTextDisplayOpen: "Find out more",
    iconOpen: "mdi-chevron-down",
    eventTextDisplayClose: "Show less",
    iconClose: "mdi-chevron-up",
  },
  {
    id: "3",
    text: "You or any member of your family to be insured do not have any unspent convictions or prosecutions pending (other than motor convictions).",
  },
  {
    id: "4",
    text: "You or any member of your family have not had any insurance cancelled, declined, declared void, or had any special terms imposed.",
  },
  {
    id: "5",
    text: "The home or the land belonging to it has not flooded in the last 10 years.",
  },
  {
    id: "6",
    text: "The property will not be left unoccupied for a total of more than 60 days in a row.",
  },
  {
    id: "7",
    text: "The property will not be used for business or professional purposes, other than clerical work undertaken by you and your family.",
  },
];

export const LANDLORD_ELIGIBILITY_COVER = [
  {
    id: "1",
    text: "The property will only be let to tenant(s) aged 18 or over",
    expandContent:
      "All tenants noted on the tenancy agreement must be aged 18 or over.",
    eventTextDisplay: "Help with tenant age",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
  {
    id: "2",
    text: "An acceptable tenancy agreement is in place for the duration of the policy",
    expandContent: `<p>The initial fixed term of the tenancy agreement must be for a minimum period of 6 months, excluding Scotland.</p>
      <p>Acceptable forms of tenancy agreements are.</p>
      <p>a) An Assured Shorthold tenancy agreement as defined within the House Act 1998 (as amended).</p>
      <p>b) A Company Residential tenancy (company let) created after 28th February 1997 where the tenant is a Private Limited Company (Ltd) or Public Limited Company (Plc) and the property is let purely for residential purposes to an employee of the tenant.</p>
      <p>c) A written common law residential tenancy agreement created after 1st October 2010 between individuals where the rent is in excess of £100,000 per annum.</p>
      <p class="mb-0">d) For tenancies in Scotland, as Short Assured Tenancy or Assured Tenancy as defined in the Housing (Scotland) Act 1998 or a Private Residential tenancy agreement created after the 1st December 2017 as defined within the Private Housing (Tenancies) (Scotland) Act 2016.</p>`,
    eventTextDisplay: "What is an acceptable tenancy agreement?",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
  {
    id: "3",
    text: "A satisfactory tenant reference is carried out on all tenant(s) or guarantor",
    expandContent: `<p>The following checks must be carried out before the commencement of the tenancy agreement or the policy, whichever is later;</p>
    <p>a) A credit check obtained from a licensed credit referencing company showing; no County Court Judgements (CCJ's) in the preceding 3 years, no outstanding CCJ's and no undischarged bankruptcies.</p>
    <p>b) Two forms of acceptable identification, one of which must be photographic.</p>
    <p>c) Affordability checks must be carried out on all tenants by the purchaser or a licensed referencing company, which confirms that the tenants have the reasonable means to pay the rent i.e. that their income, or combined income for tenancies with multiple tenants, is sufficient to pay the agreed rent in full.</p>
    <p>If the tenant(s) cannot meet the requirements of the credit check, a guarantor must be sought who can meet the requirements above.</p>
    <p class="mb-0">If the tenant is a company, a company reference must be carried out showing no CCJ’s and the agreed rent must not be greater than 85% of the company’s credit limit.</p>`,
    eventTextDisplay: "Help with tenant references",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
  {
    id: "4",
    text: "The first month’s rent has been paid, or will be paid before allowing the tenant(s) into possession of the property",
    expandContent: `<p class="mb-0"> The first month’s rent must have been received in cash or cleared funds.</p>`,
    eventTextDisplay: "Help with rent payments",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
  {
    id: "5",
    text: "All statutory pre-grant notices have been issued, or will be issued before allowing the tenant(s) into possession of the property",
    expandContent: `
    <p>Where applicable and as required by the relevant laws within each country of the UK, all necessary pre-grant notices must have been issued to the tenant to meet any regulatory requirements. </p>
    <p>The requirements may also differ depending on whether the policy is purchased in conjunction with a new or an existing tenancy agreement. Examples of pre-grant notices may include;</p>
    <ul>
      <li>Energy Performance Certificate</li>
      <li>Gas Safety Certificate</li>
      <li>How to Rent guide</li>
    </ul>
    `,
    eventTextDisplay: "Help with pre-grant notices",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
];

export const LANDLORD_ELIGIBILITY = [
  {
    id: "1",
    text: "When occupied the property will be let under a tenancy agreement directly between the letting agent or landlord and each tenant.",
  },
  {
    id: "2",
    text: "The property will not be used for any other purpose than residential.",
  },
  {
    id: "3",
    text: "The property does not have any signs of, or ever had any damage caused to it by landslip, subsidence or heave.",
  },
  {
    id: "4",
    text: "You or any member of your family do not have any unspent convictions or pending prosecutions.",
  },
  {
    id: "5",
    text: "You or any member of your family have not had insurance cancelled, declined or declared void or had any special terms applied.",
  },
  {
    id: "6",
    text: "There will not be more than 6 individual tenants occupying the property.",
  },
  {
    id: "7",
    text: "The property is not a bedsit or divided into individual self-contained units each with individual cooking facilities.",
  },
  {
    id: "8",
    text: "The property or the land belonging to it has not flooded in the last 10 years.",
  },
];

export const B2B_BUSINESS_LANDLORD_ELIGIBILITY = [
  {
    id: "1",
    text: "When occupied the property will be let under a tenancy agreement directly between the letting agent or landlord and each tenant.",
  },
  {
    id: "2",
    text: "The property will not be used for any other purpose than residential.",
  },
  {
    id: "3",
    text: "The property does not have any signs of, or ever had any damage caused to it by landslip, subsidence or heave.",
  },
  {
    id: "4",
    text: "You or any principal, director or partner involved with the business do not have any unspent convictions or pending prosecutions.",
  },
  {
    id: "5",
    text: "You or any principal, director or partner involved with the business have not had insurance cancelled, declined or declared void or had any special terms applied.",
  },
  {
    id: "6",
    text: "There will not be more than 6 individual tenants occupying the property.",
  },
  {
    id: "7",
    text: "The property is not a bedsit or divided into individual self-contained units each with individual cooking facilities.",
  },
  {
    id: "8",
    text: "The property or the land belonging to it has not flooded in the last 10 years.",
  },
];

export const LANDLORD_COMPANY_ELIGIBILITY = [
  {
    id: "1",
    text: "When occupied the property will be let under a tenancy agreement directly between the letting agent or landlord and each tenant.",
  },
  {
    id: "2",
    text: "The property will not be used for any other purpose than residential.",
  },
  {
    id: "3",
    text: "The property does not have any signs of, or ever had any damage caused to it by landslip, subsidence or heave.",
  },
  {
    id: "4",
    text: "You or any principal, director or partner involved with the limited company do not have any unspent convictions or pending prosecutions.",
  },
  {
    id: "5",
    text: "You or any principal, director or partner involved with the limited company have not had insurance cancelled, declined or declared void or had any special terms applied.",
  },
  {
    id: "6",
    text: "There will not be more than 6 individual tenants occupying the property.",
  },
  {
    id: "7",
    text: "The property is not a bedsit or divided into individual self-contained units each with individual cooking facilities.",
  },
  {
    id: "8",
    text: "The property or the land belonging to it has not flooded in the last 10 years.",
  },
];

export const TENANTS_CONTENTS_ELIGIBILITY = [
  {
    id: "1",
    text: "You do not have any unspent convictions or prosecutions pending (excluding motor convictions).",
  },
  {
    id: "2",
    text: "You’ve never had insurance cancelled, declined, declared void or had any special terms imposed because of a non-disclosure of information, fraudulent activity or misrepresentation.",
  },
  {
    id: "3",
    text: "The property will not be left unoccupied for more than 60 days in a row.",
  },
  {
    id: "4",
    text: "The property will not be used for business or professional purposes, other than clerical work.",
  },
];

export const TENANTS_LIABILITY_ELIGIBILITY = [
  {
    id: "1",
    text: "This property is my main residence and is within the United Kingdom.",
  },
  {
    id: "2",
    text: "I am currently a tenant with a tenancy agreement in place for this property.",
  },
  {
    id: "3",
    text: "I do not have Tenants Liability Insurance cover on another policy.",
  },
];

export const MPPI_ELIGIBILITY = [
  {
    id: "1",
    text: "You're aged 18 years or over but under 64 years at the policy start date. Your cover will stop when you reach 65 years of age.",
  },
  {
    id: "2",
    text: "You’re currently a resident of the UK.",
  },
  {
    id: "3",
    text: "You're actively working at least 16 hours per week. This must be paid work, this includes self-employed work, statutory maternity and parental leave, but does not include temporary work.",
  },
  {
    id: "4",
    text: "Your work is not temporary, casual, seasonal, irregular or a period of training/apprenticeship. This must be paid work, this includes self-employed work, statutory maternity and parental leave, but does not include temporary work.",
  },
  {
    id: "5",
    text: "You’re named on the mortgage agreement for the residential property which is your main home.",
  },
  {
    id: "6",
    text: "You're paying or about to pay a mortgage agreement for a residential property which is permanently occupied by you and your immediate family as your home. The mortgage start date must be within 30 days of the policy start date.",
  },
  {
    id: "7",
    text: "You are up to date with your repayments of any existing mortgage agreements.",
  },
  {
    id: "8",
    text: "You understand the pre-existing medical conditions exclusion of this policy. Pre-existing medical conditions are any conditions (whether specifically diagnosed or not) which the customer knew about, or should reasonably have known about at the policy start date, or which they received treatment for or had seen or arranged to see a doctor about during the 12 months immediately before the policy start date.",
  },
];

export const TENANTS_CONTENTS_ELIGIBILITY_INFO_MSG =
  "To continue with your quote or purchase you must confirm the following are true for you, your partner and any other person permanently living with you under your tenancy agreement:";
export const QUOTE_ELIGIBILITY_INFO_MSG =
  "To proceed with this quotation, you must be able to confirm you meet all of the below eligibility criteria.";
export const HOME_ELIGIBILITY_INFO_MSG =
  "Please confirm that you meet all of the below eligibility criteria. Take care to make sure that the information you provide is accurate to the best of your knowledge, otherwise your insurance provider could increase your premium, refuse a claim or void your policy.";
export const LANDLORD_ELIGIBILITY_INFO_MSG =
  "Please confirm that you meet all of the below eligibility criteria. Take care to ensure that the information you provide is accurate to the best of your knowledge, otherwise your premium could increase, your claim may be refused or your policy could be voided";
export const MPPI_ELIGIBILITY_INFO_MSG =
  "To continue with the quote, you must confirm the following statements are true for all applicants and make sure they are fully aware of the eligibility requirements.";
